/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";

const DigitalSubscriptionCard = () => {
  const { t } = useTranslation();

  return (
    <div className="phone1">
      {/* Header Section */}
      <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#9b59bf] dark:!border-[#3c3a3d] flex flex-col gap-y-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-xl font-bold text-[#9b59bf] dark:!text-[#9b59bf] mb-0">
              {t("SubscriptionSettings.plan.digital.header.title")}
            </h2>
            <p className="text-gray-600 dark:!text-gray-400 mb-0">
              {t("SubscriptionSettings.plan.digital.header.subtitle")}
            </p>
          </div>
          <div className="flex items-center">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
              <svg
                className="w-4 h-4 mr-1.5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              {t("SubscriptionSettings.plan.digital.header.badge")}
            </span>
          </div>
        </div>
      </div>

      {/* Main Free Trial Card */}
      <div className="bg-gradient-to-br from-purple-50 via-white to-indigo-50 dark:from-[#181819] dark:via-[#1a1a1b] dark:to-[#1c1c1d] rounded-xl shadow-lg p-8 m-3 border-2 border-[#9b59bf] dark:!border-[#3c3a3d] relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-32 h-32 opacity-10">
          <svg
            className="w-full h-full text-[#9b59bf]"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <div className="text-center relative z-10">
          {/* Gift Icon - Enhanced dark mode colors */}
          <div className="mx-auto w-20 h-20 bg-[#9b59bf] hover:bg-[#814a9f] dark:bg-[#b366d9] dark:hover:bg-[#9b59bf] rounded-full flex items-center justify-center mb-6 shadow-lg transition-colors">
            <svg
              className="w-10 h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
              />
            </svg>
          </div>

          {/* Main Title - Enhanced gradient for dark mode */}
          <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#9b59bf] to-[#814a9f] dark:from-[#c77ae0] dark:to-[#b366d9] mb-4">
            {t("SubscriptionSettings.plan.digital.main.title")}
          </h1>

          {/* Subtitle */}
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-6">
            {t("SubscriptionSettings.plan.digital.main.subtitle")}
          </h2>

          {/* Description */}
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto leading-relaxed">
            {t("SubscriptionSettings.plan.digital.main.description")}
          </p>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {/* Feature 1 */}
            <div className="dark:bg-[#242426] rounded-lg p-6 shadow-sm border border-[#9b59bf] dark:border-[#4a4a4d]">
              <div className="w-12 h-12 bg-green-100 dark:bg-green-900 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-6 h-6 text-green-600 dark:text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2">
                {t(
                  "SubscriptionSettings.plan.digital.features.unlimited.title"
                )}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t(
                  "SubscriptionSettings.plan.digital.features.unlimited.description"
                )}
              </p>
            </div>

            {/* Feature 2 */}
            <div className=" dark:bg-[#242426] rounded-lg p-6 shadow-sm border border-[#9b59bf] dark:border-[#4a4a4d]">
              <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-6 h-6 text-blue-600 dark:text-blue-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2">
                {t("SubscriptionSettings.plan.digital.features.secure.title")}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t(
                  "SubscriptionSettings.plan.digital.features.secure.description"
                )}
              </p>
            </div>

            {/* Feature 3 */}
            <div className=" dark:bg-[#242426] rounded-lg p-6 shadow-sm border border-[#9b59bf] dark:border-[#4a4a4d]">
              <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-6 h-6 text-[#9b59bf] dark:text-[#c77ae0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 11-9.75 9.75 9.75 9.75 0 019.75-9.75z"
                  />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2">
                {t("SubscriptionSettings.plan.digital.features.support.title")}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t(
                  "SubscriptionSettings.plan.digital.features.support.description"
                )}
              </p>
            </div>
          </div>

          {/* Trial Duration - Enhanced dark mode colors */}
          <div className="bg-[#9b59bf] hover:bg-[#814a9f] dark:bg-[#b366d9] dark:hover:bg-[#9b59bf] text-white rounded-xl p-6 mb-8 shadow-lg transition-colors">
            <div className="flex items-center justify-center mb-3">
              <svg
                className="w-8 h-8 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h3 className="text-xl font-semibold text-yellow-500">
                {t("SubscriptionSettings.plan.digital.trial.title")}
              </h3>
            </div>
            <p className="text-purple-100 dark:text-purple-50">
              {t("SubscriptionSettings.plan.digital.trial.description")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalSubscriptionCard;
